import { render, staticRenderFns } from "./serch-money.vue?vue&type=template&id=3daf7710&scoped=true&"
import script from "./serch-money.vue?vue&type=script&lang=js&"
export * from "./serch-money.vue?vue&type=script&lang=js&"
import style0 from "./serch-money.vue?vue&type=style&index=0&id=3daf7710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3daf7710",
  null
  
)

export default component.exports